import { IconRefresh } from "@tabler/icons-react";
import { Button } from "./Button/Button";

export default function RefreshBrowserPage() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-5 py-12">
      <div className="flex-1"></div>
      <IconRefresh size={48} stroke={1.5} />
      <h1 className="mt-6 text-center text-xl font-bold">
        A new version of Amplifiles Studio is available
      </h1>
      <p className="mt-1 text-center text-text-secondary">
        Please refresh your browser to get the latest version.
      </p>
      <Button onClick={() => window.location.reload()} className="mt-8">
        Refresh now
      </Button>

      <div className="flex-1"></div>
      <div className="">
        <a href="https://amplifiles.ai">
          <img
            src="/AmplifilesLogo.png"
            alt="Amplifiles Logo"
            className="h-8"
          />
        </a>
      </div>
    </div>
  );
}
